import { Caption2, Subtitle1 } from '@fluentui/react-components';
import React from 'react';
import { AuthHelper } from '../..//libs/auth/AuthHelper';
import { AppState, useClasses } from '../../App';
import { UserSettingsMenu } from '../header/UserSettingsMenu';
import { BackendProbe, ChatView, Error, Loading } from '../views';
import { store } from '../../redux/app/store';
import anleiLogo from '../../assets/logoanlei.png'
import { Constants } from '../../Constants';
import TenantSelector from '../TenantSelector';


const Chat = ({
    classes,
    appState,
    setAppState,
}: {
    classes: ReturnType<typeof useClasses>;
    appState: AppState;
    setAppState: (state: AppState) => void;
}) => {
    const { activeUserInfo } = store.getState().app;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment

    const tenants = React.useMemo(() => activeUserInfo?.tenants ?? [], [activeUserInfo]);

    const onBackendFound = React.useCallback(() => {
        setAppState(
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            AuthHelper.isAuthAAD()
                ? // if AAD is enabled, we need to set the active account before loading chats
                  AppState.SettingUserInfo
                : // otherwise, we can load chats immediately
                  AppState.LoadChats,
        );
    }, [setAppState]);
    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <div className={'branding'}>
                    <img src={anleiLogo} />

                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
    <Subtitle1 as="h1">{Constants.app.name}</Subtitle1>
    <Caption2 style={{ paddingTop: '10px' }}>{ 'v.1.0.0'}</Caption2>
</div>
                </div>
                {appState > AppState.SettingUserInfo && (
                    <div className={classes.cornerItems}>
                        <div className={classes.cornerItems}>
                            {tenants.length > 1 && <TenantSelector />}
                            <UserSettingsMenu
                                setLoadingState={() => {
                                    setAppState(AppState.SigningOut);
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
            {appState === AppState.ProbeForBackend && <BackendProbe onBackendFound={onBackendFound} />}
            {appState === AppState.SettingUserInfo && (
                <Loading text={'Bleiben Sie dran, während wir Ihre Informationen abrufen...'} />
            )}
            {appState === AppState.ErrorLoadingUserInfo && (
                <Error
                    text={
                        'Benutzerdaten können nicht geladen werden. Bitte versuchen Sie, sich abzumelden und erneut anzumelden.'
                    }
                />
            )}
            {appState === AppState.ErrorLoadingChats && (
                <Error text={'Chats können nicht geladen werden. Bitte versuchen Sie, die Seite zu aktualisieren.'} />
            )}
            {appState === AppState.LoadingChats && <Loading text="Chats werden geladen..." />}
            {appState === AppState.Chat && <ChatView />}
        </div>
    );
};
export default Chat;
